// extracted by mini-css-extract-plugin
export default {"component":"Footer_component__wpGwG"};